<div class="contact-container">
    <span class="contact">
       {{getAddress()}}
    </span>
</div>